import { render, staticRenderFns } from "./SignInDialog.vue?vue&type=template&id=4e15b959&scoped=true"
import script from "./SignInDialog.vue?vue&type=script&lang=js"
export * from "./SignInDialog.vue?vue&type=script&lang=js"
import style0 from "./SignInDialog.vue?vue&type=style&index=0&id=4e15b959&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e15b959",
  null
  
)

export default component.exports